module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-弹窗关闭.cc03d.png";